import React from 'react'
import HomePageNavBar from './HomePageNavBar'
import HeroSection from '../Home/HeroSection'
import Manufacturing from './Manufacturing'
import Automate from './Automate'
import SmartInventory from './SmartInventory'


function MainHomePage() {
  return (
    <div>
        <HomePageNavBar/>
        <HeroSection/>
        <Manufacturing/>
        <Automate/>
        <SmartInventory/>
    </div>
  )
}

export default MainHomePage